import * as React from "react";
import { Button } from "@progress/kendo-react-buttons";
import { toast } from "react-toastify";
import { useActiveVats } from "services/vatService";
import {
  addExpense,
  updateExpense,
  useExpenses,
} from "services/expenseService";
import ExpenseList from "./ExpenseList";
import EditExpense from "./EditExpense";

const enrichExpenses = (expenses, vats) =>
  expenses.map((expense) => {
    const vat = vats.find((item) => item.vatCodeId === expense.vatCode);
    return {
      ...expense,
      vatCodeDisplay: vat?.display || expense.vatCode,
    };
  });

const ExpenseSetup = () => {
  const [showForm, setShowForm] = React.useState(false);
  const [editItem, setEditItem] = React.useState();
  const [submitting, setSubmitting] = React.useState(false);
  const { data: expensesData = [], loading } = useExpenses();
  const { data: activeVats = [] } = useActiveVats();

  const expenses = React.useMemo(
    () => enrichExpenses(expensesData, activeVats),
    [expensesData, activeVats]
  );

  const closeForm = () => {
    setShowForm(false);
    if (editItem) setEditItem();
  };

  const enterEdit = (item) => {
    if (!item?.expenseId) {
      console.error("Missing expenseId for edit:", item);
      return;
    }
    setShowForm(true);
    setEditItem(item);
  };

  const handleSubmit = async (formData) => {
    setSubmitting(true);
    try {
      const netAmount = formData.netAmount ?? 0;
      let vatCode = formData.vatCode;
      let vatRate = formData.vatRate;
      let vatAmount = formData.vatAmount;

      if (typeof vatCode === "object" && vatCode != null) {
        vatRate = vatCode.rate;
        if (vatAmount === null || vatAmount === undefined) {
          vatAmount = (vatRate / 100) * netAmount;
        }
        vatCode = vatCode.vatCodeId;
      }

      const data = {
        details: formData.details?.trim(),
        netAmount,
        vatCode,
        vatRate: vatRate ?? 0,
        vatAmount: vatAmount ?? 0,
        nominalRef: formData.nominalRef,
        active: formData.active ?? true,
      };

      const result = editItem
        ? await updateExpense(editItem.expenseId, data)
        : await addExpense(data);

      if (result.success) {
        toast.success(editItem ? "Expense Updated" : "Expense Added");
        if (editItem) setEditItem();
        closeForm();
      }
    } catch (error) {
      console.error(error);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="d-flex flex-column h-100 w-100 settings-container-sm">
      <div className="d-flex justify-content-end mb-3 flex-shrink-0">
        <Button
          className="common-btn setting-btn"
          onClick={() => setShowForm(true)}
        >
          Add Expense
        </Button>
      </div>

      <div className="flex-grow-1 mb-2 h-100" style={{ minHeight: 0 }}>
        <ExpenseList
          expenses={expenses}
          loading={loading}
          enterEdit={enterEdit}
        />
      </div>

      {showForm && (
        <EditExpense
          cancelEdit={closeForm}
          onSubmit={handleSubmit}
          isLoading={submitting}
          item={editItem}
        />
      )}
    </div>
  );
};

export default ExpenseSetup;
